import { render, staticRenderFns } from "./ListDessert.vue?vue&type=template&id=2905cce8&"
import script from "./ListDessert.vue?vue&type=script&lang=js&"
export * from "./ListDessert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports